import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
import MainLayout from '../layouts/main';
import SimpleLayout from '../layouts/simple';
// config
import { PATH_AFTER_LOGIN } from '../config';
//
import {
  AboutPage,
  BlogListPage,
  BlogViewDetailPage,
  ChangePasswordPage,
  ComingSoonPage,
  CommissionListPage,
  CommissionPayListPage,
  ConclusionContractPage,
  Contact,
  CostCategoryListPage,
  CostManagementListPage,
  ExpenseIframePage,
  ExpenseEditKhoanMucPage,
  ExpenseCreateVoucherPage,
  ExpensePhieuChiDetailPage,
  ExpensePhieuChiEditPage,
  InvoiceIframePage,
  CrCategoryListPage,
  CustomerCarePage,
  DashboardPage,
  DebtsDetail,
  DebtsListPage,
  EmployeeListPage,
  FaqsPage,
  FileManagerPage,
  GoodCategoryListPage,
  GoodListPage,
  GroupSupermarketListPage,
  ImportInventoryListPage,
  ImportWarehouseListPage,
  InternalOrganizationListPage,
  InventoryListPage,
  InventoryManagementListPage,
  LoginPage,
  MaintenancePage,
  NewPasswordPage,
  OrderGiftDetail,
  OrderGiftPage,
  OrderSampleListPage,
  Page403,
  Page404,
  Page500,
  PartiesListPage,
  PartyTypesListPage,
  PaymentAccountListPage,
  PaymentListPage,
  PaymentOrderCreatePage,
  PaymentPage,
  PermissionDeniedPage,
  PricingPage,
  PrintOrder,
  PrintOrderGift,
  ProductReportListPage,
  ProductLotDossiersPage,
  ProductionMaterialInventoryPage,
  ProductionSemiFinishedPage,
  ProductionPurchaseOrdersPage,
  ProductionOperationsModulePage,
  ProductionOrdersPage,
  ProductionOverviewPage,
  ProductionProductsBomPage,
  ProductionReportsPage,
  RefundOrderCreatePage,
  RegisterPage,
  RenvenueCustomerListPage,
  RenvenueEmployeeListPage,
  ResetPasswordPage,
  RoleListPage,
  SaleReceiptDetailPage,
  SaleReceiptListPage,
  SaleReceiptPaymentDetaiPage,
  SupermarketListPage,
  SupermarketStoreMappingListPage,
  TagertMonthListPage,
  TargetOKRListPage,
  UserListPage,
  UserPermistionListPage,
  VerifyCodePage,
  WarehouseExportPage,
  WorkDailyListPage,
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        { path: 'login-unprotected', element: <LoginPage /> },
        { path: 'register-unprotected', element: <RegisterPage /> },
        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password', element: <NewPasswordPage /> },
            { path: 'verify', element: <VerifyCodePage /> },
          ],
        },
      ],
    },

    // Dashboard
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <DashboardPage /> },
        {
          path: 'internal-organization',
          children: [
            { element: <Navigate to="/dashboard/internal-organization/list" replace />, index: true },
            { path: 'list', element: <InternalOrganizationListPage /> },
          ],
        },
        {
          path: 'employee',
          children: [
            { element: <Navigate to="/dashboard/employee/list" replace />, index: true },
            { path: 'list', element: <EmployeeListPage /> },
          ],
        },

        {
          path: 'parties',
          children: [
            { element: <Navigate to="/dashboard/parties/list" replace />, index: true },
            { path: 'list', element: <PartiesListPage /> },
            { path: 'types', element: <PartyTypesListPage /> },
            { path: 'group-supermarket', element: <GroupSupermarketListPage /> },
            { path: 'list/:id', element: <PartiesListPage /> },
          ],
        },
        {
          path: 'commission',
          children: [
            { element: <Navigate to="/dashboard/commission/list" replace />, index: true },
            { path: 'list', element: <CommissionListPage /> },
            { path: 'pay', element: <CommissionPayListPage /> },
          ],
        },

        {
          path: 'good',
          children: [
            { element: <Navigate to="/dashboard/good/list" replace />, index: true },
            { path: 'list', element: <GoodListPage /> },
            { path: 'dossiers', element: <Navigate to="/dashboard/dossier/list" replace /> },
            { path: 'super-market', element: <SupermarketListPage /> },
          ],
        },
        {
          path: 'good',
          children: [
            { element: <Navigate to="/dashboard/good/category" replace />, index: true },
            { path: 'category', element: <GoodCategoryListPage /> },
          ],
        },
        {
          path: 'dossier',
          children: [
            { element: <Navigate to="/dashboard/dossier/list" replace />, index: true },
            { path: 'list', element: <ProductLotDossiersPage /> },
            { path: 'create', element: <ProductLotDossiersPage /> },
          ],
        },
        {
          path: 'user',
          children: [
            { element: <Navigate to="/dashboard/user/list" replace />, index: true },
            { path: 'list', element: <UserListPage /> },
            { path: 'roles', element: <RoleListPage /> },
            { path: 'permistion', element: <UserPermistionListPage /> },
          ],
        },
        {
          path: 'conclusion-contract',
          children: [
            { element: <Navigate to="/dashboard/conclusion-contract/list" replace />, index: true },
            { path: 'list', element: <ConclusionContractPage /> },
          ],
        },
        {
          path: 'parties',
          children: [
            { element: <Navigate to="/dashboard/parties/cr-list" replace />, index: true },
            { path: 'cr-list', element: <CrCategoryListPage /> },
          ],
        },
        {
          path: 'warehouse',
          children: [
            {
              path: 'import-warehouse',
              children: [
                { path: 'list', element: <ImportWarehouseListPage /> },
                { path: 'list/:id', element: <ImportWarehouseListPage /> },
              ],
            },
            {
              path: 'export-warehouse',
              children: [
                { path: 'list', element: <WarehouseExportPage /> },
                { path: 'list/:id', element: <WarehouseExportPage /> },
              ],
            },
            {
              path: 'inventory-management',
              children: [
                { element: <Navigate to="/dashboard/inventory-management/list" replace />, index: true },
                { path: 'list', element: <InventoryManagementListPage /> },
              ],
            },
          ],
        },
        {
          path: 'order',
          children: [
            // { element: <Navigate to="/dashboard/order/sale-receipt/list" replace />, index: true },
            { path: 'sale-receipt/list', element: <SaleReceiptListPage /> },
            { path: 'supermarket-store-mapping/list', element: <SupermarketStoreMappingListPage /> },
            { path: 'sale-receipt/create', element: <SaleReceiptDetailPage /> },
            { path: 'sale-receipt/create-supermarket', element: <SaleReceiptDetailPage /> },
            { path: 'sale-receipt/:id/:currentMode', element: <SaleReceiptDetailPage /> },
            { path: 'sale-receipt/detailPayment/:id/:currentMode', element: <SaleReceiptPaymentDetaiPage /> },
            { path: 'order-sample/list/', element: <OrderSampleListPage /> },
            { path: 'order-gift/list', element: <OrderGiftPage /> },
            { path: 'order-gift/create/:type', element: <OrderGiftDetail /> },
            { path: 'order-gift/:id/:currentMode', element: <OrderGiftDetail /> },
            { path: 'refund-order/create', element: <RefundOrderCreatePage /> },
            { path: 'refund-order/:id/:mode', element: <RefundOrderCreatePage /> },
          ],
        },
        {
          path: 'payment',
          children: [
            // { element: <Navigate to="/dashboard/payment/list" replace />, index: true },
            { path: 'list', element: <PaymentListPage /> },
            { path: 'create', element: <PaymentOrderCreatePage /> },
            { path: ':id/:currentMode', element: <PaymentOrderCreatePage /> },
            { path: ':id/:currentMode', element: <PaymentOrderCreatePage /> },
            { path: 'account', element: <PaymentAccountListPage /> },
          ],
        },
        { path: 'permission-denied', element: <PermissionDeniedPage /> },
        {
          path: 'work-daily',
          children: [
            { element: <Navigate to="/dashboard/work-daily/list" replace />, index: true },
            { path: 'list', element: <WorkDailyListPage /> },
          ],
        },
        {
          path: 'parties',
          children: [
            { element: <Navigate to="/dashboard/parties/customer-care" replace />, index: true },
            { path: 'customer-care', element: <CustomerCarePage /> },
          ],
        },
        {
          path: 'file-manager',
          children: [
            { path: 'list', element: <FileManagerPage /> },
            { path: 'list/:id', element: <FileManagerPage /> },
          ],
        },
        {
          path: 'cost-management',
          children: [
            { path: 'list', element: <CostManagementListPage /> },
            { path: 'category', element: <CostCategoryListPage /> },
          ],
        },
        {
          path: 'expense',
          children: [
            { element: <Navigate to="/dashboard/expense/phieu-chi" replace />, index: true },
            { path: 'phieu-chi', element: <ExpenseIframePage sub="" /> },
            { path: 'phieu-chi/tao', element: <ExpenseCreateVoucherPage /> },
            { path: 'phieu-chi/:id', element: <ExpensePhieuChiDetailPage /> },
            { path: 'phieu-chi/:id/edit', element: <ExpensePhieuChiEditPage /> },
            { path: 'khoan-muc', element: <ExpenseIframePage sub="/danh-muc/khoan-muc" /> },
            { path: 'khoan-muc/them', element: <ExpenseIframePage sub="/danh-muc/them-khoan-muc" /> },
            { path: 'khoan-muc/:id', element: <ExpenseEditKhoanMucPage /> },
            { path: 'nha-cung-cap', element: <ExpenseIframePage sub="/danh-muc/nha-cung-cap" /> },
          ],
        },
        { path: 'invoice-inbox', element: <InvoiceIframePage /> },
        {
          path: 'okr-target',
          children: [
            { element: <Navigate to="/dashboard/okr-target/okr-list" replace />, index: true },
            { path: 'okr-list', element: <TargetOKRListPage /> },
            { path: 'target-month/list', element: <TagertMonthListPage /> },
          ],
        },
        {
          path: 'debts',

          children: [
            { element: <Navigate to="/dashboard/debts/list" replace />, index: true },
            { path: 'list', element: <DebtsListPage /> },
            { path: ':id', element: <DebtsDetail /> },
          ],
        },
        {
          path: 'renvenue-customer',
          children: [
            { element: <Navigate to="/dashboard/renvenue-customer/list" replace />, index: true },
            { path: 'list', element: <RenvenueCustomerListPage /> },
          ],
        },
        {
          path: 'renvenue-employee',
          children: [
            { element: <Navigate to="/dashboard/renvenue-employee/list" replace />, index: true },
            { path: 'list', element: <RenvenueEmployeeListPage /> },
          ],
        },
        {
          path: 'import-inventory',
          children: [
            { element: <Navigate to="/dashboard/import-inventory/list" replace />, index: true },
            { path: 'list', element: <ImportInventoryListPage /> },
          ],
        },
        {
          path: 'inventory',
          children: [
            { element: <Navigate to="/dashboard/inventory/list" replace />, index: true },
            { path: 'list', element: <InventoryListPage /> },
          ],
        },
        {
          path: 'good-report',
          children: [
            { element: <Navigate to="/dashboard/good-report/list" replace />, index: true },
            { path: 'list', element: <ProductReportListPage /> },
          ],
        },
        {
          path: 'blog',
          children: [
            { element: <Navigate to="/dashboard/blog/list" replace />, index: true },
            { path: 'list', element: <BlogListPage /> },
            { path: 'list/:id', element: <BlogViewDetailPage /> },
          ],
        },
        {
          path: 'production-operations',
          element: <ProductionOperationsModulePage />,
          children: [
            { element: <Navigate to="overview" replace />, index: true },
            { path: 'overview', element: <ProductionOverviewPage /> },
            { path: 'products-bom', element: <ProductionProductsBomPage /> },
            { path: 'material-inventory', element: <ProductionMaterialInventoryPage /> },
            { path: 'semi-finished', element: <ProductionSemiFinishedPage /> },
            { path: 'purchase-orders', element: <ProductionPurchaseOrdersPage /> },
            { path: 'orders', element: <ProductionOrdersPage /> },
            { path: 'reports', element: <ProductionReportsPage /> },
          ],
        },
        { path: 'account/:type', element: <ChangePasswordPage /> },
      ],
    },

    // Main Routes
    {
      element: <MainLayout />,
      children: [
        { element: <Navigate to={'auth/login'} replace />, index: true },
        { path: 'about-us', element: <AboutPage /> },
        { path: 'contact-us', element: <Contact /> },
        { path: 'faqs', element: <FaqsPage /> },
        // Demo Components
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { path: 'pricing', element: <PricingPage /> },
        { path: 'payment', element: <PaymentPage /> },
      ],
    },
    {
      children: [
        {
          path: 'print',
          element: <PrintOrder />,
        },
        {
          path: 'print/gift',
          element: <PrintOrderGift />,
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: 'maintenance', element: <MaintenancePage /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
